module.exports = __webpack_public_path__ + "img/zgyd.c8b791f9.png";